import React from 'react'
import { Button } from 'reactstrap'
import EuroIcon from '@mui/icons-material/Euro'
import { CircularProgress } from '@mui/material'

function AddPaymentButton(props) {
  const { onClick, loading, disabled } = props

  return (
    <div className='actions-right'>
      <Button disabled={loading || disabled} color='info' size='sm' onClick={onClick}>
        <EuroIcon fontSize={'inherit'} />
        {loading ? <CircularProgress size={10} /> : ' Lisää maksu'}
      </Button>
    </div>
  )
}

export default AddPaymentButton
